import * as React from "react";

import WaitAssistanceCard from '../components/WaitAssistanceCard.jsx'
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import * as ApiCall from '../ApiCall.jsx';

const NOTIFICATION_INTERVAL = 6000;

// Page to display requests for assistance from customers
// will put a notification dot on the tab if a new request comes in.
export default function WaitAssistance({setNotification}) {

  const [requests, setRequests] = React.useState([]);

  function getRequests() {
    return requests;
  }

  const [state, setState] = React.useState("loading");

  //apicalls to get updated assists list
  //if there is an additional assist request compared to last time, and user not currently on this tab add notification
  //load the content onto the page
  function getAss() {
    ApiCall.get("/wait_staff/assistanceTables")
    .then((tables) => {
      let reqTables = [];
      for (let i = 0; i < tables.length; i++) {
        reqTables.push(tables[i]);
      }
      
      setRequests(reqTables);
      if (requests.length != reqTables.length) {        
        setNotification(true);
      }
      setState("success");
    })
    .catch((msg) => {
      alert("Failed to get requests: " + msg)
    })
  }

  React.useEffect(() => { 
    getAss();
  }, []);

  React.useEffect(() => {
    const interval = setInterval(() => {
      getAss();
    }, NOTIFICATION_INTERVAL);

    return () => clearInterval(interval);        
  }, [requests]);


  function find(thing, array) {
    for (let i = 0; i < array.length; i++) {
      if (array[i] === thing) {
        return i
      }
    }
    return -1;
  }


  function closeRequest(tableNumber) {
    ApiCall.post("/wait_staff/cancelAssistance", "tableNumber="+tableNumber)
    .then(() => {
      //remove from requests list
      let copy = [...requests];
      let ind = find(tableNumber, copy)
      copy.splice(ind, 1);
      setRequests(copy);
    })
    .catch((msg) => {
      alert("Failed to cancel: "+ msg);
    })    
  }
 
  if (state === "success") {
    return (
      <Container sx={{display: 'flex', flexDirection: 'column', alignItems: 'center' , gap: 1, pt: 2}}>
        { 
          requests.map((tableNum) => (
            <WaitAssistanceCard key={tableNum} tableNumber={tableNum} close={closeRequest} ></WaitAssistanceCard>
          ))
        }
      </Container>
    );
  }

  else if (state === "loading") {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }
};